import { endpoints } from '../../../api/domains/endpoints';
import api from '../../../api';

export function getProfileAPI({ body, token, traceId, store }) {
    return api.get(endpoints().profile, body, { token, traceId }, store);
}
